import React from "react";
import { styled } from "@mui/material";

// 원본 스타일 유지
const ContactSubmit = styled("input")(() => ({
  display: "block",
  width: "400px",
  height: "60px",
  margin: "80px auto 0 auto",
  borderRadius: "30px",
  backgroundColor: "#14f1a5",
  color: "#1f1f1f",
  fontSize: "22px",
  fontWeight: 700,
  letterSpacing: "-1px",
  cursor: "pointer",
  border: "none",
  marginBottom: "6rem",

  "@media (max-width: 1000px)": {
    width: "312px",
    marginTop: "60px",
  },
}));

export const ContactSubmitButton: React.FC = () => (
  <ContactSubmit type="submit" value="프로젝트 문의등록" />
);
